var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("notifications", {
    staticClass: "min-w-128",
    attrs: {
      group: _vm.toastOptions.group,
      position: _vm.toastOptions.position,
      max: _vm.toastOptions.max,
      duration: _vm.toastOptions.duration,
      closeOnClick: _vm.toastOptions.closeOnClick,
      ignoreDuplicates: _vm.toastOptions.ignoreDuplicates,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function ({ item, close }) {
          return [
            _c(
              "warning-box",
              {
                staticClass: "mt-3",
                class: {
                  "cursor-pointer": item.data?.showCloseButton || false,
                },
                attrs: { type: item.type, "show-right-slot": "" },
                on: { click: close },
                scopedSlots: _vm._u(
                  [
                    item.data?.showCloseButton
                      ? {
                          key: "rightPart",
                          fn: function () {
                            return [
                              _c("svg-icon", {
                                staticClass: "icon-xs",
                                attrs: { name: "close" },
                                on: { click: close },
                              }),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              },
              [
                _c("div", { staticClass: "flex flex-col" }, [
                  item.title
                    ? _c("div", { staticClass: "font-bold" }, [
                        _vm._v(" " + _vm._s(item.title) + " "),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "w-full" }, [
                    Array.isArray(item.text)
                      ? _c(
                          "div",
                          { staticClass: "flex flex-col" },
                          _vm._l(item.text, function (text, key) {
                            return _c("div", { key: key }, [
                              _c("li", { staticClass: "list-inside" }, [
                                _vm._v(_vm._s(text)),
                              ]),
                            ])
                          }),
                          0
                        )
                      : _c("span", [_vm._v(_vm._s(item.text))]),
                  ]),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }